module.exports = __webpack_public_path__ + "static/img/Withdrawal.728e0d1e.png";